import { mapState, mapGetters } from 'vuex'

export default {
  computed: {
    ...mapState('app', ['BRAND_CODE', 'settings']),
    ...mapGetters('app', ['BRAND'])
  }
}
